import request from '../../axios';

export const getAllListLoanRequest = async (
  payload?: IListLoanRequestPayload,
) => {
  const {data}: {data: ILoanRequestItem[]} = await request.get(
    `/api/v2/payment/list-loan-request`,
    {
      params: payload,
    },
  );

  return data;
};
